!(function (t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "undefined" != typeof exports
      ? (module.exports = t(require("jquery")))
      : t(jQuery);
  })(function (t) {
    (t.fn.marquee = function (e) {
      return this.each(function () {
        var a,
          r,
          n,
          i,
          s,
          o = t.extend({}, t.fn.marquee.defaults, e),
          u = t(this),
          d = 3,
          p = "animation-play-state",
          l = !1,
          f = function (t, e, a) {
            for (
              var r = ["webkit", "moz", "MS", "o", ""], n = 0;
              n < r.length;
              n++
            )
              r[n] || (e = e.toLowerCase()), t.addEventListener(r[n] + e, a, !1);
          },
          c = function () {
            u.timer = setTimeout(D, o.delayBeforeStart);
          },
          m = {
            pause: function () {
              l && o.allowCss3Support
                ? a.css(p, "paused")
                : t.fn.pause && a.pause(),
                u.data("runningStatus", "paused"),
                u.trigger("paused");
            },
            resume: function () {
              l && o.allowCss3Support
                ? a.css(p, "running")
                : t.fn.resume && a.resume(),
                u.data("runningStatus", "resumed"),
                u.trigger("resumed");
            },
            toggle: function () {
              m["resumed" === u.data("runningStatus") ? "pause" : "resume"]();
            },
            destroy: function () {
              clearTimeout(u.timer),
                u.find("*").addBack().off(),
                u.html(u.find(".tpl-js-marquee:first").html());
            },
          };
        if ("string" != typeof e) {
          var g;
          t.each(o, function (t) {
            if (void 0 !== (g = u.attr("data-" + t))) {
              switch (g) {
                case "true":
                  g = !0;
                  break;
                case "false":
                  g = !1;
              }
              o[t] = g;
            }
          }),
            o.speed && (o.duration = (parseInt(u.width(), 10) / o.speed) * 1e3),
            (i = "up" === o.direction || "down" === o.direction),
            (o.gap = o.duplicated ? parseInt(o.gap) : 0),
            u.wrapInner('<div class="tpl-js-marquee"></div>');
          var h = u
            .find(".tpl-js-marquee")
            .css({ "margin-right": o.gap, float: "left" });
          if (o.duplicated) {
            var v,
              y,
              x,
              I,
              w = u.parents(".tpl-marquee");
            i
              ? ((y = w.height()), (x = u.height()), (v = Math.floor(y / x) + 1))
              : ((I = w.width()), (r = u.width()), (v = Math.floor(I / r) + 1));
            for (let t = 1; t <= v; t++) h.clone(!0).appendTo(u);
          }
          if (
            (u.wrapInner(
              '<div style="width:1000000px" class="tpl-js-marquee-wrapper"></div>'
            ),
            (a = u.find(".tpl-js-marquee-wrapper")),
            i)
          ) {
            a.removeAttr("style"),
              u.height(x),
              u
                .find(".tpl-js-marquee")
                .css({
                  float: "none",
                  "margin-bottom": o.gap,
                  "margin-right": 0,
                }),
              o.duplicated &&
                u.find(".tpl-js-marquee:last").css({ "margin-bottom": 0 });
            var S = u.find(".tpl-js-marquee:first").height() + o.gap;
            o.startVisible && !o.duplicated
              ? ((o._completeDuration =
                  ((parseInt(S, 10) + parseInt(x, 10)) / parseInt(x, 10)) *
                  o.duration),
                (o.duration = (parseInt(S, 10) / parseInt(x, 10)) * o.duration))
              : (o.duration =
                  ((parseInt(S, 10) + parseInt(x, 10)) / parseInt(x, 10)) *
                  o.duration);
          } else
            (s = u.find(".tpl-js-marquee:first").width() + o.gap),
              o.startVisible && !o.duplicated
                ? ((o._completeDuration =
                    ((parseInt(s, 10) + parseInt(r, 10)) / parseInt(r, 10)) *
                    o.duration),
                  (o.duration = (parseInt(s, 10) / parseInt(r, 10)) * o.duration))
                : (o.duration =
                    ((parseInt(s, 10) + parseInt(r, 10)) / parseInt(r, 10)) *
                    o.duration);
          if (
            (o.duplicated && (o.duration = o.duration / 2), o.allowCss3Support)
          ) {
            var q = document.body || document.createElement("div"),
              b = "marqueeAnimation-" + Math.floor(1e7 * Math.random()),
              j = "Webkit Moz O ms Khtml".split(" "),
              C = "animation",
              V = "",
              k = "";
            if (
              (void 0 !== q.style.animation &&
                ((k = "@keyframes " + b + " "), (l = !0)),
              !1 === l)
            )
              for (var A = 0; A < j.length; A++)
                if (void 0 !== q.style[j[A] + "AnimationName"]) {
                  var B = "-" + j[A].toLowerCase() + "-";
                  (C = B + C),
                    (p = B + p),
                    (k = "@" + B + "keyframes " + b + " "),
                    (l = !0);
                  break;
                }
            l &&
              ((V =
                b +
                " " +
                o.duration / 1e3 +
                "s " +
                o.delayBeforeStart / 1e3 +
                "s infinite " +
                o.css3easing),
              u.data("css3AnimationIsSupported", !0));
          }
          var X = function () {
              a.css(
                "transform",
                "translateY(" +
                  ("up" === o.direction ? x + "px" : "-" + S + "px") +
                  ")"
              );
            },
            Y = function () {
              a.css(
                "transform",
                "translateX(" +
                  ("left" === o.direction ? r + "px" : "-" + s + "px") +
                  ")"
              );
            };
          o.duplicated
            ? (i
                ? o.startVisible
                  ? a.css("transform", "translateY(0)")
                  : a.css(
                      "transform",
                      "translateY(" +
                        ("up" === o.direction
                          ? x + "px"
                          : "-" + (2 * S - o.gap) + "px") +
                        ")"
                    )
                : o.startVisible
                ? a.css("transform", "translateX(0)")
                : a.css(
                    "transform",
                    "translateX(" +
                      ("left" === o.direction
                        ? r + "px"
                        : "-" + (2 * s - o.gap) + "px") +
                      ")"
                  ),
              o.startVisible || (d = 1))
            : o.startVisible
            ? (d = 2)
            : i
            ? X()
            : Y();
          var D = function () {
            if (
              (o.duplicated &&
                (1 === d
                  ? ((o._originalDuration = o.duration),
                    (o.duration = i
                      ? "up" === o.direction
                        ? o.duration + x / (S / o.duration)
                        : 2 * o.duration
                      : "left" === o.direction
                      ? o.duration + r / (s / o.duration)
                      : 2 * o.duration),
                    V &&
                      (V =
                        b +
                        " " +
                        o.duration / 1e3 +
                        "s " +
                        o.delayBeforeStart / 1e3 +
                        "s " +
                        o.css3easing),
                    d++)
                  : 2 === d &&
                    ((o.duration = o._originalDuration),
                    V &&
                      ((b += "0"),
                      (k = t.trim(k) + "0 "),
                      (V =
                        b +
                        " " +
                        o.duration / 1e3 +
                        "s 0s infinite " +
                        o.css3easing)),
                    d++)),
              i
                ? o.duplicated
                  ? (d > 2 &&
                      a.css(
                        "transform",
                        "translateY(" +
                          ("up" === o.direction ? 0 : "-" + S + "px") +
                          ")"
                      ),
                    (n = {
                      transform:
                        "translateY(" +
                        ("up" === o.direction ? "-" + S + "px" : 0) +
                        ")",
                    }))
                  : o.startVisible
                  ? 2 === d
                    ? (V &&
                        (V =
                          b +
                          " " +
                          o.duration / 1e3 +
                          "s " +
                          o.delayBeforeStart / 1e3 +
                          "s " +
                          o.css3easing),
                      (n = {
                        transform:
                          "translateY(" +
                          ("up" === o.direction ? "-" + S + "px" : x + "px") +
                          ")",
                      }),
                      d++)
                    : 3 === d &&
                      ((o.duration = o._completeDuration),
                      V &&
                        ((b += "0"),
                        (k = t.trim(k) + "0 "),
                        (V =
                          b +
                          " " +
                          o.duration / 1e3 +
                          "s 0s infinite " +
                          o.css3easing)),
                      X())
                  : (X(),
                    (n = {
                      transform:
                        "translateY(" +
                        ("up" === o.direction
                          ? "-" + a.height() + "px"
                          : x + "px") +
                        ")",
                    }))
                : o.duplicated
                ? (d > 2 &&
                    a.css(
                      "transform",
                      "translateX(" +
                        ("left" === o.direction ? 0 : "-" + s + "px") +
                        ")"
                    ),
                  (n = {
                    transform:
                      "translateX(" +
                      ("left" === o.direction ? "-" + s + "px" : 0) +
                      ")",
                  }))
                : o.startVisible
                ? 2 === d
                  ? (V &&
                      (V =
                        b +
                        " " +
                        o.duration / 1e3 +
                        "s " +
                        o.delayBeforeStart / 1e3 +
                        "s " +
                        o.css3easing),
                    (n = {
                      transform:
                        "translateX(" +
                        ("left" === o.direction ? "-" + s + "px" : r + "px") +
                        ")",
                    }),
                    d++)
                  : 3 === d &&
                    ((o.duration = o._completeDuration),
                    V &&
                      ((b += "0"),
                      (k = t.trim(k) + "0 "),
                      (V =
                        b +
                        " " +
                        o.duration / 1e3 +
                        "s 0s infinite " +
                        o.css3easing)),
                    Y())
                : (Y(),
                  (n = {
                    transform:
                      "translateX(" +
                      ("left" === o.direction ? "-" + s + "px" : r + "px") +
                      ")",
                  })),
              u.trigger("beforeStarting"),
              l)
            ) {
              a.css(C, V);
              var e =
                  k +
                  " { 100%  " +
                  (function (t) {
                    var e = [];
                    for (var a in t)
                      t.hasOwnProperty(a) && e.push(a + ":" + t[a]);
                    return e.push(), "{" + e.join(",") + "}";
                  })(n) +
                  "}",
                p = a.find("style");
              0 !== p.length
                ? p.filter(":last").html(e)
                : t("head").append("<style>" + e + "</style>"),
                f(a[0], "AnimationIteration", function () {
                  u.trigger("finished");
                }),
                f(a[0], "AnimationEnd", function () {
                  D(), u.trigger("finished");
                });
            } else
              a.animate(n, o.duration, o.easing, function () {
                u.trigger("finished"), o.pauseOnCycle ? c() : D();
              });
            u.data("runningStatus", "resumed");
          };
          u.on("pause", m.pause),
            u.on("resume", m.resume),
            o.pauseOnHover &&
              (u.on("mouseenter", m.pause), u.on("mouseleave", m.resume)),
            l && o.allowCss3Support ? D() : c();
        } else t.isFunction(m[e]) && (a || (a = u.find(".tpl-js-marquee-wrapper")), !0 === u.data("css3AnimationIsSupported") && (l = !0), m[e]());
      });
    }),
      (t.fn.marquee.defaults = {
        allowCss3Support: !0,
        css3easing: "linear",
        easing: "linear",
        delayBeforeStart: 1e3,
        direction: "left",
        duplicated: !1,
        duration: 5e3,
        speed: 0,
        gap: 20,
        pauseOnCycle: !1,
        pauseOnHover: !1,
        startVisible: !1,
      });
  });
  